import { axiosInstance } from "../axiosInstance";

export const getAllCustomerOrders = async (data) => {
  const { userId } = data;
  return axiosInstance({
    method: "post",
    url: "customer_estimate_flow_service.php",
    data: {
      user_id: userId,
      estimate_status: "all_v1",
    },
  });
};
export const saveCustomerDetails = async (data) => {
  return axiosInstance({
    method: "post",
    url: "customer_update_service.php",
    data: data,
  });
};

export const fetchCustomerProfile = async (userId) => {
  return axiosInstance({
    method: "post",
    url: "customer_get_service_by_id.php",
    data: { user_id: userId },
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json;charset=utf-8",
    },
  });
};
export const checkIfUserExists = async (data) => {
  return axiosInstance({
    method: "post",
    url: "checkUserExists.php",
    data: data,
  });
};

export const updateMovingDateInfoAPI = async (data) => {
  return axiosInstance({
    method: "post",
    url: "estimate_update_date.php",
    data: data,
  });
};

export const updateAdditionalInfoAPI = async (data) => {
  return axiosInstance({
    method: "post",
    url: "estimate_update_additional_info.php",
    data: data,
  });
};

export const updateHouseDetailsAPI = async (data) => {
  return axiosInstance({
    method: "post",
    url: "estimate_update_house.php",
    data: data,
  });
};

export const getInventoryDataByEstimateId = async (data) => {
  return axiosInstance({
    method: "post",
    url: "estimate_search_service.php",
    data: data,
  });
};

export const updateInventoryItems = async (data) => {
  return axiosInstance({
    method: "post",
    url: "estimate_items_update.php",
    data: data,
  });
};

export const updateEstimateReview = async (data) => {
  return axiosInstance({
    method: "post",
    url: "estimate_review_service.php",
    data: data,
  });
};
export const getAdditionalListOfGoodsFiles = async (data) => {
  const formData = new FormData();
  formData.append("type", "view_by_id");
  formData.append("estimate_id", data["estimate_id"]);
  return axiosInstance({
    method: "post",
    url: "estimate_additional_files.php",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateStorageItemsAPI = async (data) =>{
  return axiosInstance({
    method: "post",
    url: "storage_items_update.php",
    data: data,
  }); 
}

export const checkAlternatePhoneNumber = async (data) => {
  return axiosInstance({
    method:"post",
    url:"check_for_alternate_number.php",
    data:data
  });
};